import { createBrowserHistory } from 'history';
import Route, { Params, ParamsToReplaceType, replaceRouteParams } from 'routes/Routes';
import { Link } from 'types/Link';
import { NO_LINK_SELECTED } from './link';
import { pageView, trackRouteWithParamsView } from 'services/googleAnalytics/GATracker';

const browserHistory = createBrowserHistory();

export default browserHistory;

export const navigate = (path: string, options = {hasSelectedChannelParam: true}): void => {
  const {hasSelectedChannelParam} = options;
  browserHistory.push(path);

  window.dispatchEvent(new CustomEvent('urlchanged'));

  if (!hasSelectedChannelParam) {
    pageView(path);
  }
};

type NavigateParams = ParamsToReplaceType & {
  track?: boolean;
}

export const navigateToChannelRoute = (channel: string, route: Route, params: NavigateParams = {}): void => {
  const {track = true, ...rest} = params;
  const newRoute = replaceRouteParams(route, {
    ...rest,
    [Params.SELECTED_CHANNEL]: channel
  });

  navigate(newRoute);
  if (track) trackRouteWithParamsView(route);
};

export const navigateToSelectedChannelRoute = (selectedLink: Link | undefined, route: Route, params?: NavigateParams): void => {
  navigateToChannelRoute(selectedLink?.channelKey || NO_LINK_SELECTED, route, params);
};

export const navigateToVideoCall = (selectedLink: Link | undefined, videoCallID: string): void => {
  navigateToSelectedChannelRoute(selectedLink, Route.VIDEO_CALL, {
    [Params.VIDEO_CALL_ID]: videoCallID,
    track: false,
  });
};

export const navigateToAssociate = (uuid: string): void => {
  const newRoute = replaceRouteParams(Route.ACCEPT_RELATIONSHIP, {
    [Params.UUID]: uuid,
  });

  navigate(newRoute, {hasSelectedChannelParam: false});
};

export const navigateToPartnerContents = (selectedLink: Link | undefined, partnerId: string): void => {
  navigateToSelectedChannelRoute(selectedLink, Route.PARTNER_CONTENTS, {
    [Params.PARTNER_ID]: partnerId,
  });
};

export const navigateToAdminMessageViewer = (selectedLink: Link | undefined, key: string): void => {
  navigateToSelectedChannelRoute(selectedLink, Route.ADMIN_MESSAGE_VIEWER, {
    [Params.KEY]: key,
  });
};

export const navigateToVideoCallList = (selectedLink: Link): void => {
  const route = replaceRouteParams(Route.VIDEO_CALL_LIST, {
    [Params.SELECTED_CHANNEL]: selectedLink.channelKey
  });

  navigate(route, { hasSelectedChannelParam: false });
}

export const navigateToVideoCallpage = (roomName: string): void => {
  const route = replaceRouteParams(Route.VIDEO_CALL_PAGE, {
    [Params.VIDEO_CALL_ID]: roomName
  });

  navigate(route, { hasSelectedChannelParam: false });
}

export const navigateToVideoCallpageWithChannel = (selectedLink: Link, roomName: string): void => {
  const route = replaceRouteParams(Route.VIDEO_CALL_PAGE_WITH_CHANNEL, {
    [Params.SELECTED_CHANNEL]: selectedLink.channelKey,
    [Params.VIDEO_CALL_ID]: roomName
  });

  navigate(route, { hasSelectedChannelParam: false });
}